import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Template } from '../../Components/Template/template'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { Link, useParams } from 'react-router-dom'
import {
    AlertType, Cidade, ContatoFornecedor, DadosCNPJ, Estado, FornecedorAttributes, InputsRefs, RetAPI, barraVermelhoAzul, bgBlue, bgRed,
    classBorderLabelDark, classBt, classDivBackground, classDivBody, classDtCriarAtt, classInput, classInputDark, classLabel, classLabelDark,
    classUserCriarAtt, classWeigthBt, classbtAzul, classbtCinzaClaro, classbtColunasAzul, classbtColunasVermelho, focusLabelRed, focusRed
} from '../../Utils/Types'
import { IoSave, IoEye } from 'react-icons/io5'
import { FcNook } from 'react-icons/fc'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope, faFolder, faClipboardList } from '@fortawesome/free-solid-svg-icons'
import { Icone } from '../../Components/Icones/Index'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import { FornecedorService } from './FornecedorService'
import { ModalConsultaCNPJ } from '../../Components/ModalConsultaCNPJ/modal-consulta-cnpj'
import InputMask from 'react-input-mask'
import { cpf, cnpj } from 'cpf-cnpj-validator'
import moment from 'moment'
import { SearchBox } from '../../Components/SearchBox/SearchBox'
import { Funcoes } from '../../Utils/Funcoes'
import { ModalExcluirDados } from '../../Components/Modal/ModalExcluirDados'
import { ModalAuditoria } from '../../Components/ModalAuditoria/modal_auditoria'
import { UtilServices } from '../../Utils/UtilServices'
import { AiOutlineClear } from 'react-icons/ai'
import { FaRegQuestionCircle, FaVideo } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'
import { ModalImportacao } from '../../Components/Modal/modalImportacao'
import { useSelector } from 'react-redux'
import { selectUser } from '../../Components/Redux/userSlice'
import { GridContatoFornecedor } from '../../Components/GridProducts/GridContatoFornecedor'
import { ModalTutorial } from '../../Components/Modal/modal-tutorial'

type CampoObrigatorio = {
    campo: string,
    erro: boolean,
}

export const FornecedorNew = () => {

    // código comentado
    /*
    const docValidation: CampoObrigatorio[] = [

        { campo: 'cpfCnpj', erro: false },   // Posição 0 do Array. 
    ]

    const cepValidation: CampoObrigatorio[] = [

        { campo: 'cep', erro: false },  // Posição 0 do Array.
    ]
    //const [CamposObrigatoriosDoc, setCamposObrigatoriosDoc] = useState<CampoObrigatorio[]>(docValidation)
    //const [CamposObrigatoriosCep, setCamposObrigatoriosCep] = useState<CampoObrigatorio[]>(cepValidation)
    */

    // ----------------- TABS --------------------------------------------------------
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        { index: 1, titulo: 'Contatos', active: false, icon: faEnvelope },
        { index: 2, titulo: 'Auditoria', active: false, icon: faClipboardList },

    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)

    // ------------- CAMPOS OBRIGATORIOS ----------------------------------------------
    const fieldsMandatory: CampoObrigatorio[] = [
        { campo: 'cnpj_cpf', erro: false },  // Posição 0 do Array. 
        { campo: 'nome', erro: false },  // Posição 1 do Array.
        { campo: 'estado', erro: false },  // Posição 2 do Array. 
        { campo: 'id_cidade', erro: false },  // Posição 3 do Array. 
    ]

    const [CamposObrigatorios, setCamposObrigatorios] = useState<CampoObrigatorio[]>(fieldsMandatory)

    // ------------------ ATRIBUTOS ---------------------------------------------------
    const { idForn } = useParams()
    const [id, setId] = useState(0)
    const [attributes, setAttributes] = useState<FornecedorAttributes>()

    // COLUNA 1 
    const [tipoPessoa, setTipoPessoa] = useState('F')
    const [cpfCnpj, setCpfCnpj] = useState('')
    const [nomeRazao, setNomeRazao] = useState('')
    const [nomeRazaoCopia, setNomeRazaoCopia] = useState('')
    const [nomeFantasia, setNomeFantasia] = useState('')
    const [ieRg, setIeRg] = useState('')
    const [ativo, setAtivo] = useState('S')
    const [observacao, setObservacao] = useState('')

    // COLUNA 2
    const [cep, setCep] = useState('')
    const [endereco, setEndereco] = useState('')
    const [bairro, setBairro] = useState('')
    const [numero, setNumero] = useState('')
    const [complemento, setComplemento] = useState("")
    const [idUf, setIdUf] = useState(0)
    const [uf, setUf] = useState<Estado[]>([])
    const [siglaUf, setSiglaUf] = useState("")
    const [idCity, setIdCity] = useState(0)
    const [cidade, setCidade] = useState<Cidade[]>([])

    const [idOrigem, setIdOrigem] = useState(0)

    // ---------- ATRIBUTOS CONTATO --------------------------------------------------
    const [fornecedores, setFornecedores] = useState<ContatoFornecedor[]>([])
    const [idContatoForn, setIdContatoForn] = useState(0)
    const [nomeContatoForn, setNomeContatoForn] = useState("")
    const [nomeContatoExcluir, setNomeContatoExcluir] = useState("")
    const [emailContatoForn, setEmailContatoForn] = useState("")
    const [setorContatoForn, setSetorContatoForn] = useState("")
    const [foneContatoForn, setFoneContatoForn] = useState("")
    const [celContatoForn, setCelContatoForn] = useState("")
    const [listContato, setListContato] = useState<ContatoFornecedor[]>([])

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS EXCLUSÃO --------------------------------------------------
    const [modalShow, setModalShow] = useState(false)
    const [idExcluir, setIdExcluir] = useState(0)
    const [loadingExcluir, setLoadingExcluir] = useState(false)

    // ---------- ATRIBUTOS AUDITORIA -------------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    // ---------- ATRIBUTOS AUDITORIA CONTATO -----------------------------------------
    const [listAuditoriaContato, setListAuditoriaContato] = useState<ContatoFornecedor>()

    // ---------- MODALS --------------------------------------------------------------
    const [modalConsultaVisible, setModalConsultaVisible] = useState(false)
    const [modalAuditoriaVisible, setModalAuditoriaVisible] = useState(false)

    // --------- lOADING --------------------------------------------------------------
    const [loadingCnpj, setLoadingCnpj] = useState(false)
    const [loadingConsultaCEP, setLoadingConsultaCEP] = useState<boolean>(false)

    // --------- SEARCHBOX ------------------------------------------------------------
    const [visibleSearchBoxUF, setVisibleSearchBoxUF] = useState<boolean>(false)
    const [visibleSearchBoxCity, setVisibleSearchBoxCity] = useState<boolean>(false)

    // -------- IMPORTAÇÃO ------------------------------------------------------------
    const [visibleImportacao, setVisibleImportacao] = useState<boolean>(false)

    // -------- TEMA ------------------------------------------------------------------
    let user = useSelector(state => selectUser(state))

    // ---------- ATRIBUTOS TUTORIAL --------------------------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const dadosEmpresaLogada = () => {

        const dadosEmpresa = Funcoes.GetDadosEmpresa()

        if (dadosEmpresa !== null) {

            const dadosLocalStorage = dadosEmpresa

            const ufEmpresa = dadosLocalStorage.uf

            const estado = [...attributes?.estados || []].filter((uf) => uf.sigla === ufEmpresa)

            if (estado && estado.length > 0) {
                setIdUf(estado[0].id)
                setarCidades(estado[0].sigla)
                setSiglaUf(estado[0].sigla)

            }
        }
    }

    const getAttributes = async () => {
        setLoading(true)

        try {

            const attr = await FornecedorService.GetAttributes(idForn)

            setAttributes(attr.data)
            setUf(attr.data.estados)
            //setCidade(attr.cidades)

            const dadosEmpresa = Funcoes.GetDadosEmpresa()

            if (dadosEmpresa !== null) {

                const dadosLocalStorage = dadosEmpresa

                const ufEmpresa = dadosLocalStorage.uf

                const estado = attr.data.estados.filter((uf: any) => uf.sigla === ufEmpresa)

                if (estado && estado.length > 0) {
                    setIdUf(estado[0].id)
                    setarCidades(estado[0].sigla)
                    setSiglaUf(estado[0].sigla)
                }
            }

            if (attr.data && idForn) {

                const citys = attr.data.cidades.filter((item: any) => item.id === attr.data.fornecedor?.id_cidade)
                if (citys && citys.length > 0) {
                    setIdCity(citys[0].id)
                }

                const estado = attr.data.estados.filter((uf: any) => uf.sigla === attr.data.fornecedor?.uf)
                if (estado && estado.length > 0) {
                    setIdUf(estado[0].id)
                }

                setId(attr.data.fornecedor?.id || 0)
                setTipoPessoa(attr.data.fornecedor?.tipo_pessoa || 'F')
                setCpfCnpj(attr.data.fornecedor?.cnpj_cpf || '')
                setNomeRazao(attr.data.fornecedor?.nome || '')
                setNomeRazaoCopia(attr.data.fornecedor?.nome || '')
                setNomeFantasia(attr.data.fornecedor?.nome_fantasia || '')
                setIeRg(attr.data.fornecedor?.ie_rg || '')
                setAtivo(attr.data.fornecedor?.ativo || 'S')
                setObservacao(attr.data.fornecedor?.observacao || '')
                setIdOrigem(attr.data.fornecedor?.id_origem || 0)

                setCep(attr.data.fornecedor?.cep?.toString() || '')
                setEndereco(attr.data.fornecedor?.endereco || '')
                setBairro(attr.data.fornecedor?.bairro || '')
                setNumero(attr.data.fornecedor?.numero || '')
                setComplemento(attr.data.fornecedor?.complemento || '')
                setSiglaUf(attr.data.fornecedor?.uf || "")

                //setIdCidade(attr.fornecedor?.id_cidade || 0)
                //const dataFormatada = moment(attr.fornecedor?.dt_cadastro?.toString() || '').format('DD/MM/YYYY')
                //setDtCadastro(dataFormatada)

                if (attr.data.fornecedor?.dt_cadastro) {
                    const dataFormatadaCriacao = moment(attr.data.fornecedor?.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }


                if (attr.data.fornecedor?.dt_last_update) {
                    const dataFormatadaAtt = moment(attr.data.fornecedor?.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setUserCriador(attr.data.fornecedor.name_user_insert || '')
                setUsertAtt(attr.data.fornecedor.name_user_last_update || '')

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados`)

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAttributes()
        uppContacts()
        inputFocus()
    }, [])

    useEffect(() => {
        const newCitys = attributes?.cidades.filter((item: Cidade) => {
            return item.uf.trim() === (attributes?.fornecedor?.uf.trim() || siglaUf)
        })

        setCidade(newCitys || [])
    }, [attributes])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
        searchBoxFocus()
    }

    useEffect(() => {

        if (tabs[0].active) {
            inputFocus()
        } else {
            InputfocusContato()
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- INPUTS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const tipoPessoaChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipoPessoa(e.target.value)
    }

    const cpfCnpjChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value.replaceAll('.', '').replaceAll('_', '').replaceAll('-', '').replaceAll('/', '')
        setCpfCnpj(inputValue)
    }

    const nomeRazaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNomeRazao(e.target.value)
    }

    const nomeFantasiaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNomeFantasia(e.target.value)
    }

    const ieRgChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIeRg(e.target.value)
    }

    const ativoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setAtivo(e.target.value)
    }

    const observacaoChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setObservacao(e.target.value)
    }

    const cepChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value.replaceAll('_', '').replaceAll('-', '')
        setCep(inputValue)

        if (e.target.value && Funcoes.onlyNumber(e.target.value).length === 8) {
            consultarCep(e.target.value)
        } else if (e.target.value && Funcoes.onlyNumber(e.target.value).length === 0) {

            setEndereco('')
            setBairro('')
            setNumero('')
            setComplemento('')
            setIdCity(0)
            dadosEmpresaLogada()

            updateUfList()
        }
    }

    const consultarCep = async (cep: string) => {

        setVisible(false)
        setLoadingConsultaCEP(true)

        try {

            const dadosCEP = await Funcoes.ConsultaCEP(cep)

            if (dadosCEP.error) {

                dadosEmpresaLogada()
                setIdCity(0)
                setBairro('')
                setComplemento('')
                setEndereco('')

            } else {

                updateUfList()

                const estado = [...attributes?.estados || []].filter((item) => item.sigla === dadosCEP.data.uf)
                if (estado && estado.length > 0) {
                    setIdUf(estado[0].id)
                    setarCidades(estado[0].sigla)
                    setSiglaUf(estado[0].sigla)
                }

                const cidade = [...attributes?.cidades || []].filter((item) => item.id === dadosCEP.data.ibge)
                if (cidade && cidade.length > 0) {
                    setIdCity(cidade[0].id)
                }

                setBairro(dadosCEP.data.bairro)
                setComplemento(dadosCEP.data.complemento)
                setEndereco(dadosCEP.data.logradouro)

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível consultar o CEP. Por favor, tente novamente`)

        } finally {
            setLoadingConsultaCEP(false)
        }
    }

    const logradouroChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEndereco(e.target.value)
    }

    const bairroChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBairro(e.target.value)
    }

    const numeroChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumero(e.target.value.replace(/[^0-9]/g, ''))
    }

    const complementoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setComplemento(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ESTADO --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearUfSelecionada = useCallback(() => {
        setSiglaUf("")
        setIdUf(0)

        updateUfList()

        setCidade([])
        setIdCity(0)

        setVisibleSearchBoxUF(false)
        boxFocusUF()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */

    }, [attributes?.estados])

    const handleFilterUfClick = useCallback(async (description: string) => {

        if (description === "") {
            updateUfList()
        } else {

            const newUfList = [...attributes?.estados || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setUf(newUfList || [])
        }

    }, [attributes?.estados])

    const handleUfSelectClick = useCallback((v: Estado) => {

        if (v.id > 0) {

            setIdUf(v.id)
            setSiglaUf(v.sigla)
            setarCidades(v.sigla)

        } else {
            setIdUf(0)
            setSiglaUf('')
            setarCidades('')
        }

        updateUfList()

        setIdCity(0)

        setVisibleSearchBoxUF(false)
        boxFocusUF()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */
    }, [attributes?.estados])

    const updateUfList = () => {
        const newUfList = [...attributes?.estados || []]
        setUf(newUfList)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CIDADE --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearCidadeSelecionada = useCallback(() => {
        setIdCity(0)
        setarCidades(siglaUf)

        setVisibleSearchBoxCity(false)
        boxFocusCidade()

        /*
        if (idUf === 0) {
            const newCidadeList = [...attributes?.cidades || []]
            setCidade(newCidadeList)
            setIdCity(0)
        }
        */

    }, [uf, siglaUf])

    const handleFilterCidadeClick = useCallback(async (description: string) => {

        if (description.trim() === "") {

            setarCidades(siglaUf)
            //const newCidadeList = [...attributes?.cidades || []]
            //setCidade(newCidadeList)

        } else {

            let newCidadeList = []


            newCidadeList = [...attributes?.cidades || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.trim().toLocaleLowerCase()) &&
                    item.uf === siglaUf
            })

            /*
            if (idUf > 0) {
                newCidadeList = [...attributes?.cidades || []].filter((item) => {
                    return item.description.toLocaleLowerCase().startsWith(description.trim().toLocaleLowerCase()) &&
                        item.uf === siglaUf
                })

            } else {

                newCidadeList = [...attributes?.cidades || []].filter((item) => {
                    return item.description.toLocaleLowerCase().startsWith(description.trim().toLocaleLowerCase())
                })
            }
            */

            setCidade(newCidadeList)
        }

    }, [uf, siglaUf])

    const handleCidadeSelectClick = useCallback((v: Cidade) => {

        if (v) {
            setIdCity(v.id)
            setarCidades(siglaUf)
        }

        setVisibleSearchBoxCity(false)
        boxFocusCidade()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */
        // setIdCidade(v.codIBGE)
    }, [uf, siglaUf])

    const setarCidades = async (uf: string) => {
        const citys = await attributes?.cidades.filter(item => item.uf === uf)
        setCidade(citys || [])
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CONTATO -------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const changeNomeContatoTransp = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNomeContatoForn(e.target.value)
    }

    const changeEmailContatoForn = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        setEmailContatoForn(value)
    }

    const changeFoneContatoForn = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFoneContatoForn(e.target.value)
    }

    const changeCelContatoForn = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCelContatoForn(e.target.value)
    }

    const changeSetorContatoForn = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSetorContatoForn(e.target.value)
    }

    const InputfocusContato = () => {
        const inputElement = document.getElementById("nome_contato_forn")
        inputElement?.focus()
    }

    const novoContatoFornecedor = () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setIdContatoForn(0)
        setNomeContatoForn("")
        setEmailContatoForn("")
        setFoneContatoForn("")
        setCelContatoForn("")
        setSetorContatoForn("")

        setListContato([])

        const inputContactName = document.getElementById('nome_contato_forn')

        if (inputContactName) {
            inputContactName.focus()
        }

    }

    const handleContatoSave = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }
        setLoading(true)

        try {

            const contato: ContatoFornecedor = {
                id: idContatoForn,
                nome: nomeContatoForn,
                telefone: foneContatoForn,
                email: emailContatoForn,
                celular: celContatoForn,
                setor: setorContatoForn,
                id_fornecedor: id,
                empresaId: 0
            }


            if (id === 0) {

                const timer = setTimeout(() => {

                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(`Favor salvar um fornecedor antes de cadastrar um contato`)

                    clearTimeout(timer)
                }, 250)

            } else {

                const retAPI: RetAPI = await FornecedorService.CreateContact(contato)

                if (retAPI.error) {
                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(retAPI.msg || ``)

                } else {

                    setVisible(true)
                    setIdContatoForn(retAPI.id || 0)
                    setMessageType('SUCCESS')
                    setMessage(idContatoForn > 0 ? `Dados do contato do fornecedor atualizados com sucesso` : retAPI.msg || ``)

                    uppContacts()

                    setIdContatoForn(0)
                    setNomeContatoForn("")
                    setEmailContatoForn("")
                    setSetorContatoForn("")
                    setFoneContatoForn("")
                    setCelContatoForn("")
                }
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(idContatoForn > 0 ? `Não foi possível atualizar os dados do contato. Por favor, tente novamente` : `Não foi possível salvar os dados do contato. Por favor, tente novamente`)

        } finally {
            InputfocusContato()
            setListContato([])
            setLoading(false)
        }

    }

    const handleContactEdit = useCallback((item: ContatoFornecedor) => {

        if (listContato.length > 0) {
            setListContato([])
        }

        setMessageType((prevMessageType) => {
            if (prevMessageType === 'DANGER') {
                setVisible(false)
            }
            return prevMessageType // Mantém o valor inalterado
        })

        setIdContatoForn(item.id || 0)
        setNomeContatoForn(item.nome || '')
        setEmailContatoForn(item.email || '')
        //setIsEmailValid(validateEmail(item.email || ''))
        setSetorContatoForn(item.setor || '')
        setFoneContatoForn(item.telefone || '')
        setCelContatoForn(item.celular || '')

        setListContato([item])
        InputfocusContato()

    }, [])

    const uppContacts = async () => {
        if (parseInt(idForn || id.toString()) > 0) {

            try {

                const newContactsList = await FornecedorService.BuscarContatos(parseInt(idForn || id.toString()) || 0)
                setFornecedores(newContactsList.data)

            } catch (error) {

                setVisible(true)
                setMessageType('DANGER')
                setMessage(`Houve um erro ao buscar os contatos atualizados`)

            }
        }
    }

    const handleExcluirClick = useCallback(async (item: ContatoFornecedor) => {

        setMessageType((prevMessageType) => {
            if (prevMessageType === 'DANGER') {
                setVisible(false)
            }
            return prevMessageType // Mantém o valor inalterado
        })

        setModalShow(true)
        setIdExcluir(item.id || 0)
        setNomeContatoExcluir(item.nome || '')

        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

        if (divPerfil) {
            divPerfil.classList.add('hidden')
        }

    }, [])

    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setVisible(false)
        setLoadingExcluir(true)

        try {

            const retAPI = await FornecedorService.DeleteContato(idExcluir, motivo, senha)

            if (!retAPI.error) {
                handleReloatContacts()

                if (idContatoForn === idExcluir) {
                    novoContatoFornecedor()
                }

                const timer = setTimeout(() => {
                    setModalShow(false)
                }, 1000)

                return () => clearTimeout(timer)

            } else {
                handleReloatContactsError(retAPI.msg || 'Erro ao exlcuir')

            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível excluir o contato. Por favor, tente novamente`)

        } finally {
            setLoadingExcluir(false)
        }

    }, [idExcluir, idContatoForn])

    const handleReloatContacts = async () => {
        setVisible(false)

        const timer = setTimeout(() => {
            setVisible(true)
            setMessageType("SUCCESS")
            setMessage(`Contato excluído com sucesso`)
            uppContacts()

        }, 150)

        return () => clearTimeout(timer)
    }

    const handleReloatContactsError = async (msg: string) => {
        setVisible(false)

        const timer = setTimeout(() => {
            setVisible(true)
            setMessageType("DANGER")
            setMessage(msg)
            uppContacts()
        }, 150)

        return () => clearTimeout(timer)

    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- AUDITORIA ------------------------------------------------------------------------ ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const abrirModalContatoAuditoria = useCallback((item: ContatoFornecedor) => {
        setListAuditoriaContato(item)
        setModalAuditoriaVisible(true)

        setMessageType((prevMessageType) => {
            if (prevMessageType === 'DANGER') {
                setVisible(false)
            }
            return prevMessageType // Mantém o valor inalterado
        })
    }, [])

    const fecharModalAuditoria = useCallback(() => {
        setModalAuditoriaVisible(false)
    }, [])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FORNECEDOR ----------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const novoFornecedor = () => {

        //setSiglaUf('')
        //const newCidadeList = [...attributes?.cidades || []]
        //setCidade(newCidadeList)

        setId(0)
        setTipoPessoa('F')
        setCpfCnpj('')
        setNomeRazao('')
        setNomeFantasia('')
        setIeRg('')
        setAtivo('S')
        setObservacao('')
        setCep('')
        setEndereco('')
        setBairro('')
        setNumero('')
        setComplemento('')
        setIdCity(0)
        setIdOrigem(0)

        updateUfList()
        dadosEmpresaLogada()

        setFornecedores([])

        setDtCriador('')
        setUserCriador('')
        setDtAtt('')
        setUsertAtt('')

        searchBoxFocus()

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        redefinirCampos()
        inputFocus()
    }

    const handleSaveFornecedor = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setLoading(true)
        searchBoxFocus()

        try {

            let forne = {
                id: id,
                tipo_pessoa: tipoPessoa,
                cnpj_cpf: Funcoes.FormatDoc(cpfCnpj),
                nome: nomeRazao,
                nome_fantasia: nomeFantasia,
                ie_rg: ieRg,
                ativo: ativo === 'S' ? 'S' : 'N',
                observacao: observacao,
                cep: cep != '' && cep.length === 8 ? Funcoes.FormatCep(cep) : '',
                endereco: endereco,
                bairro: bairro,
                numero: numero,
                complemento: complemento,
                uf: siglaUf,
                id_cidade: idCity,
                id_origem: idOrigem
            }

            if (cep.length > 0 && cep.length < 8) {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(`CEP digitado inválido`)
                    clearTimeout(timer)
                }, 250)

                return
            }

            const resp = await FornecedorService.Save(forne)


            if (resp.error === true) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || ``)
                //checkDadosObrigatorios(resp.field || '')

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setId(resp.id || 0)
                setMessage(id > 0 ? `Dados do fornecedor atualizados com sucesso` : resp.msg || ``)

                if (resp.dt_cadastro) {
                    const dataFormatadaCriacao = moment(resp.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (resp.dt_last_update) {
                    const dataFormatadaAtt = moment(resp.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setNomeRazaoCopia(resp.data.fornecedor.nome)
                setUserCriador(resp.name_user_insert || '')
                setUsertAtt(resp.name_user_last_update || '')

                redefinirCampos()
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(id > 0 ? `Não foi possível atualizar os dados do fornecedor. Por favor, tente novamente` : `Não foi possível salvar os dados do fornecedor. Por favor, tente novamente`)

        } finally {
            const timer = setTimeout(() => {
                setLoading(false)
                inputFocus()
                clearTimeout(timer)
            }, 1200)
        }
    }

    const abrirModalConsultaCNPJ = () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setModalConsultaVisible(true)
        searchBoxFocus()
    }

    const fecharModalConsultaCNPJ = useCallback(() => {
        setVisible(false)
        setModalConsultaVisible(false)
        inputFocus()
    }, [])

    const inputFocusCNPJ = () => {
        const inputElement = document.getElementById("inputCNPJ")
        inputElement?.focus()
    }

    const handleConsultarCNPJ = useCallback(async (CNPJ: string) => {

        setVisible(false)
        setLoadingCnpj(true)

        try {

            if (CNPJ !== '' && cnpj.isValid(CNPJ)) {

                const dadosCNPJ: DadosCNPJ = await UtilServices.ConsultarCNPJ(CNPJ)

                if (dadosCNPJ.razao) {

                    updateUfList()

                    setNomeRazao(dadosCNPJ.razao || '')
                    setNomeFantasia(dadosCNPJ.fantasia || dadosCNPJ.razao)
                    setEndereco(dadosCNPJ.logradouro || '')
                    setBairro(dadosCNPJ.bairro || '')
                    setNumero(dadosCNPJ.numero?.toString() || '')
                    setCep(dadosCNPJ.cep.replaceAll('.', '').replaceAll('-', '') || '')
                    setComplemento(dadosCNPJ.compl || '')
                    setBairro(dadosCNPJ.bairro || '')
                    setCpfCnpj(dadosCNPJ.cnpj.replaceAll('.', '').replaceAll('_', '').replaceAll('-', '').replaceAll('/', '') || '')
                    setSiglaUf(dadosCNPJ.uf || '')
                    setarCidades(dadosCNPJ.uf || '')
                    setIdUf(dadosCNPJ.id_uf || 0)
                    setIdCity(dadosCNPJ.id_cidade || 0)
                    setAtivo('S')
                    setTipoPessoa('J')
                    setModalConsultaVisible(false)

                } else {

                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(`Erro ao localizar CNPJ`)

                    inputFocusCNPJ()
                }

            } else {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(`CNPJ inválido`)
                    setLoadingCnpj(false)

                    inputFocusCNPJ()

                    clearTimeout(timer)
                }, 250)
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível consultar o CNPJ. Por favor, tente novamente`)

            inputFocusCNPJ()

        } finally {
            setLoadingCnpj(false)
        }

    }, [attributes?.estados])

    const checkDadosObrigatorios = (field: string): boolean => {

        if (cpfCnpj.trim() === '' || (tipoPessoa === 'F' && (!(cpf.isValid(cpfCnpj)) || !(cpfCnpj.replaceAll(".", "").replaceAll("-", "").replaceAll("_", "").length === 11))) || (tipoPessoa === 'J' && (!(cnpj.isValid(cpfCnpj)) || !(cpfCnpj.replaceAll(".", "").replaceAll("/", "").replaceAll("-", "").replaceAll("_", "").length === 14)))) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (nomeRazao.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (siglaUf.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (idCity <= 0) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        return false
    }

    const redefinirCampos = async () => {
        let fieldsM: CampoObrigatorio[] = [
            { campo: 'cnpj_cpf', erro: false },  // Posição 0 do Array. 
            { campo: 'nome', erro: false },  // Posição 1 do Array.
            { campo: 'estado', erro: false },  // Posição 2 do Array. 
            { campo: 'id_cidade', erro: false },  // Posição 3 do Array.
        ]

        setCamposObrigatorios(fieldsM)
    }

    const inputFocus = () => {
        const inputElement = document.getElementById("cnpj_cpf")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- MODALS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const fecharModalExclusao = useCallback(() => {

        if (messageType == 'SUCCESS') {
            setModalShow(false)
        }

        setVisible(false)
    }, [messageType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setVisible(false)
        setModalShow(false)
    }, [])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 1 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefs: InputsRefs = {
        tipoPessoa: useRef(null),
        cpfCnpj: useRef(null),
        nomeRazao: useRef(null),
        nomeFantasia: useRef(null),
        ieRg: useRef(null),
        ativo: useRef(null),
        observacao: useRef(null),
        cep: useRef(null),
        endereco: useRef(null),
        bairro: useRef(null),
        numero: useRef(null),
        complemento: useRef(null),
        uf: useRef(null),
        cidade: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[0].active) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            searchBoxFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefs[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            if (nextIndex === 12) {
                setVisibleSearchBoxUF(true)
                inputFocusUF()
            }

            if (nextIndex === 13) {
                setVisibleSearchBoxCity(true)
                inputFocusCidade()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefs[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && tabs[0].active) {

                event.preventDefault()

                const inputSearchUf = document.getElementById('inputSearchBox-uf') as HTMLInputElement
                const inputSearchCidade = document.getElementById('inputSearchBox-cidade') as HTMLInputElement

                if (document.activeElement === inputSearchUf) {

                    clickSearchBoxCidade()
                    setVisibleSearchBoxUF(false)

                } else if (document.activeElement === inputSearchCidade) {
                    inputsRefs['tipoPessoa'].current?.focus()
                    setVisibleSearchBoxCity(false)
                }

            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [tabs])

    const searchBoxFocus = () => {
        setVisibleSearchBoxUF(false)
        setVisibleSearchBoxCity(false)
    }

    // UF -------------------------------------------------
    const boxFocusUF = () => {
        // Move o foco para o input correspondente à chave 'uf'.
        inputsRefs['uf'].current?.focus()
    }

    const clickSearchBoxUF = useCallback(() => {
        setVisibleSearchBoxUF((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxCity(false) // Fecha o City ao abrir UF
                inputFocusUF() // Foca no input UF ao abrir
            }
            return newState
        })

        boxFocusUF() // Sempre executa ao clicar
    }, [])

    const inputFocusUF = () => {
        let inputSearch = document.getElementById(`inputSearchBox-uf`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // CIDADE -------------------------------------------------
    const boxFocusCidade = () => {
        // Move o foco para o input correspondente à chave 'cidade'.
        inputsRefs['cidade'].current?.focus()
    }

    const clickSearchBoxCidade = useCallback(() => {
        setVisibleSearchBoxCity((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxUF(false) // Fecha o UF ao abrir City
                inputFocusCidade() // Foca no input Cidade ao abrir
            }
            return newState
        })

        boxFocusCidade() // Sempre executa ao clicar
    }, [])

    const inputFocusCidade = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cidade`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 2 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefsContato: InputsRefs = {
        nomeContato: useRef(null),
        emailContato: useRef(null),
        telefoneContato: useRef(null),
        celularContato: useRef(null),
        descricaoContato: useRef(null),
    }

    const handleTabPressContato = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[1].active) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefsContato)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefsContato[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefsContato[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 3 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab' && tabs[2].active) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {
            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- IMPORTAÇÃO ----------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const abrirModalImportacao = () => {
        setVisibleImportacao(true)

        if (messageType === 'DANGER') {
            setVisible(false)
        }
    }

    const fecharModalImportacao = useCallback(() => {
        setVisibleImportacao(false)
        setVisible(false)

        if (tabs[0].active) {
            inputFocus()
        } else {
            InputfocusContato()
        }
    }, [tabs])

    const formFields = [
        { pl: "CPF / CNPJ", bd: "cnpj_cpf" },
        { pl: "Nome / Razão Social", bd: "nome" },
        { pl: "Nome Fantasia / Apelido", bd: "nome_fantasia" },
        { pl: "Insc. Estadual / RG", bd: "ie_rg" },
        { pl: "Observação", bd: "observacao" },
        { pl: "CEP", bd: "cep" },
        { pl: "Logradouro", bd: "endereco" },
        { pl: "Bairro", bd: "bairro" },
        { pl: "Número", bd: "numero" },
        { pl: "Complemento", bd: "complemento" },
        { pl: "UF", bd: "uf" },
        { pl: "Cidade", bd: "id_cidade" },
    ]

    const importarDados = useCallback(async (planilha: any, mapa: any) => {

        setVisible(false)
        setLoading(true)

        try {

            const dados = await FornecedorService.FornecedorImportacao(planilha, mapa)

            if (dados.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(`planilha de importação não enviada`)

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setMessage(`Dados importados com sucesso`)

                setVisibleImportacao(false)
                inputFocus()
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível concluir a importação. Por favor, tente novamente`)

        } finally {
            setLoading(false)
        }

    }, [])


    //------------------------------------------------------------------- CÓDIGOS SEM USO ----------------------------------------------------------------------------------- ||
    const handleValidation = () => {
        /*
        if (cpf.isValid(cpfCnpj) || cnpj.isValid(cpfCnpj)) {
            setVisible(false)

            let fieldsM: CampoObrigatorio[] = [

                { campo: 'cpfCnpj', erro: false },   // Posição 3 do Array. 

            ]

            // setCamposObrigatoriosDoc(fieldsM)

        } else {
            setVisible(true)
            setMessageType('DANGER')
            setMessage(`CPF / CNPJ inválidos`)

            let fieldsM: CampoObrigatorio[] = [

                { campo: 'cpfCnpj', erro: true },   // Posição 3 do Array. 

            ]

            //  setCamposObrigatoriosDoc(fieldsM)


        }
            */
    }

    const buscarCidadePorCep = () => {
        /*
        if (cep.replace(".", "").length === 9) { // Verifique se o CEP tem 8 dígitos
            axios.get(`https://viacep.com.br/ws/${cep.replace(".", "")}/json/`)
                .then((response: any) => {
                    const { ibge, uf, bairro, complemento, logradouro, erro } = response.data

                    if (!erro) {
                        //setarCidades(uf)
                        //setSiglaUf(uf)
                        //setIdCidade(ibge)
                        setBairro(bairro)
                        setComplemento(complemento)
                        setEndereco(logradouro)

                    } else {
                        //setarCidades('')
                        //setSiglaUf('')
                        //setIdCidade(0)
                        setBairro('')
                        setComplemento('')
                        setEndereco('')

                    }
                })
                .catch((error: any) => {
                    //setarCidades('')
                    //setSiglaUf('')
                    //setIdCidade(0)
                    setBairro('')
                    setComplemento('')
                    setEndereco('')

                })
        }
        else {
            //setarCidades('')
            //setSiglaUf('')
            //setIdCidade(0)
            setBairro('')
            setComplemento('')
            setEndereco('')

        }
            */
    }

    const maskTipoPessoa = tipoPessoa != '' && tipoPessoa === 'F' ? '999.999.999-99' : '99.999.999/9999-99'
    const ativoEdit = parseInt(idForn || '0') > 0 ? false : true
    const btNovoVisible = parseInt(idForn || '') > 0 ? 'invisible hidden' : 'visible'

    const condCnpjCpf = tipoPessoa === 'F' && cpf.isValid(cpfCnpj) ? bgBlue : tipoPessoa === 'J' && cnpj.isValid(cpfCnpj) ? bgBlue : bgRed
    const condIeRg = tipoPessoa === 'J' && ieRg === ''
    const condCell = celContatoForn.replace(/[()_\s-]/g, '').length === 11 && celContatoForn.replace(/[()_\s-]/g, '') != '' || foneContatoForn.replace(/[()_\s-]/g, '') != '' ? bgBlue : bgRed
    const condFone = foneContatoForn.replace(/[()_\s-]/g, '').length === 10 && foneContatoForn.replace(/[()_\s-]/g, '') != '' || celContatoForn.replace(/[()_\s-]/g, '') != '' ? bgBlue : bgRed

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div id='div-body' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`grid grid-cols-12`}>

                            <div className={`col-span-12 h-[50px] w-full flex items-center my-3 px-2`}>

                                <FcNook className={`text-slate-700 dark:text-slate-200 ml-2 mr-2`} size="25px" color='#333' />
                                <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all mx-2`}>{parseInt(idForn || '') || id > 0 ? `Editar - Fornecedor - ${nomeRazaoCopia}` : 'Cadastro - Fornecedor'}</span>

                                <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} shadow-md shadow-blue-600`}  >
                                    <FaVideo />
                                    <span className='mx-1'>Tutorial</span>
                                </button>
                            </div>

                            {/*
                            <div className={`col-span-2 xl:col-span-1 h-[50px] w-full flex items-center my-3 px-2`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} data-tooltip-id={'tooltip-btn-dados'} id={'btn-dados'} onClick={abrirModalImportacao}>
                                    <FaFileDownload size="25px" />
                                    <Tooltip style={{ backgroundColor: user.modeDark === 'dark' ? '#B6B060' : '#166794' }} id={'tooltip-btn-dados'} anchorSelect={'#btn-dados'} positionStrategy="fixed" place='left' >
                                        <span>Importar Dados</span>
                                    </Tooltip>
                                </button>
                            </div>
                            */}


                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {tabs.map((item) => {
                                    return (
                                        <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                            className={`px-4 font-mono font-bold w-[180px]
                                                ${item.active ?
                                                    `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                    `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                } `}>
                                            <div tabIndex={-1} className={`flex items-center`}>
                                                <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                <span className={`text-sm roboto whitespace-nowrap`}>{item.titulo}</span>
                                            </div>
                                        </button>
                                    )
                                })}

                            </div>

                            <div className={`${tabs[0].active ? 'block' : 'hidden'} relative`}>

                                <div className={`flex flex-col sm:flex-row`}>

                                    <div className={`w-full h-auto grid gap-5 grid-cols-12 p-4`}>

                                        <div className={`relative col-span-12 space-y-1`}>
                                            <div className={`flex flex-row`}>
                                                <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>Dados Pessoais</span>
                                                <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 cursor-pointer`} size={18} />
                                                <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                    <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                                </Tooltip>
                                            </div>
                                            <hr className="h-px border-0 bg-slate-300 dark:bg-slate-700" />
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-5 md:col-span-4 xl:col-span-3`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <select ref={inputsRefs.tipoPessoa} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'tipoPessoa')} id="tipoPessoa" className={`${classInput} ${classInputDark}`} value={tipoPessoa} onFocus={searchBoxFocus} onChange={tipoPessoaChange}>
                                                <option value="F">Física</option>
                                                <option value="J">Jurídica</option>
                                            </select>
                                            <label htmlFor="tipoPessoa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Pessoa</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-7 md:col-span-8 xl:col-span-4`}>
                                            <div className={`${barraVermelhoAzul} ${condCnpjCpf}`} />
                                            <InputMask ref={inputsRefs.cpfCnpj} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'cpfCnpj')} id="cnpj_cpf" className={`${classInput} ${classInputDark} ${condCnpjCpf == 'bg-red-900' ? focusRed : ``}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={cpfCnpj} onFocus={searchBoxFocus} onChange={cpfCnpjChange} mask={maskTipoPessoa} alwaysShowMask={true} />
                                            <label htmlFor="cnpj_cpf" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${condCnpjCpf == 'bg-red-900' ? focusLabelRed : ``}`}>{tipoPessoa != '' && tipoPessoa === 'F' ? 'CPF' : 'CNPJ'}</label>
                                        </div>

                                        <div className={`relative col-span-12 `}>
                                            <div className={`${barraVermelhoAzul} ${nomeRazao != '' ? bgBlue : bgRed}`} />
                                            <input ref={inputsRefs.nomeRazao} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'nomeRazao')} id="nomeRazao" className={`${classInput} ${classInputDark} ${nomeRazao != '' ? '' : focusRed}`} type='text' inputMode='text' maxLength={100} placeholder=" " autoComplete='off' value={nomeRazao} onFocus={searchBoxFocus} onChange={nomeRazaoChange} />
                                            <label htmlFor="nomeRazao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${nomeRazao != '' ? '' : focusLabelRed}`}>{tipoPessoa != '' && tipoPessoa === 'F' ? 'Nome' : 'Razão Social'}</label>
                                        </div>

                                        <div className={`relative col-span-12 xl:col-span-6`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.nomeFantasia} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'nomeFantasia')} id="nomeFantasia" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={100} placeholder=" " autoComplete='off' value={nomeFantasia} onFocus={searchBoxFocus} onChange={nomeFantasiaChange} />
                                            <label htmlFor="nomeFantasia" className={`${classLabel} ${classLabelDark}  ${classBorderLabelDark}`}>{tipoPessoa != '' && tipoPessoa === 'F' ? `Apelido` : `Nome Fantasia`}</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-8 xl:col-span-4`}>
                                            <div className={`${barraVermelhoAzul} ${condIeRg ? bgRed : bgBlue}`} />
                                            <input ref={inputsRefs.ieRg} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'ieRg')} id="ieRg" className={`${classInput} ${classInputDark}  ${condIeRg ? focusRed : ''}`} type='text' inputMode='text' maxLength={20} placeholder=" " autoComplete='off' value={ieRg} onFocus={searchBoxFocus} onChange={ieRgChange} />
                                            <label htmlFor="ieRg" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${condIeRg ? focusLabelRed : ''}`}>{tipoPessoa != '' && tipoPessoa === 'F' ? 'Rg' : 'Insc. Estadual'}</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <select ref={inputsRefs.ativo} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'ativo')} id="ativo" disabled={ativoEdit} className={`${classInput} ${classInputDark} ${parseInt(idForn || '0') > 0 ? '' : 'cursor-not-allowed'}`} value={ativo} onFocus={searchBoxFocus} onChange={ativoChange}>
                                                <option value="S">Sim</option>
                                                <option value="N">Não</option>
                                            </select>
                                            <label htmlFor="ativo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Ativo</label>
                                        </div>

                                        <div className={`relative col-span-12`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue} bottom-1 dark:bottom-1`} />
                                            <textarea ref={inputsRefs.observacao} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'observacao')} id="obs" className={`${classInput} ${classInputDark} min-h-[160px] lg:min-h-[120px] resize-none`} placeholder=" " autoComplete='off' value={observacao} onFocus={searchBoxFocus} onChange={observacaoChange} />
                                            <label htmlFor="obs" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação</label>
                                        </div>

                                    </div>

                                    <div className={`w-full sm:h-[50px] grid gap-5 grid-cols-12 p-4`}>

                                        <div className={`relative col-span-12 space-y-1`}>
                                            <span className='text-[14px] text-[#ACACAC] dark:text-slate-300'>Endereço</span>
                                            <hr className="h-px border-0 bg-slate-300 dark:bg-slate-700" />
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-5 lg:col-span-4 xl:col-span-3`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <div className='absolute flex items-center h-full px-2'>

                                                {loadingConsultaCEP &&
                                                    <div className={`absolute h-[20px] w-[20px] animate-spin rounded-full ml-1 border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                        <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                    </div>
                                                }

                                            </div>
                                            <InputMask ref={inputsRefs.cep} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'cep')} id="cep" className={`${classInput} ${classInputDark} ${loadingConsultaCEP ? 'pl-10' : ''}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={cep} onFocus={searchBoxFocus} onChange={cepChange} mask="99999-999" alwaysShowMask={true} />
                                            <label htmlFor="cep" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Cep</label>
                                        </div>

                                        <div className={`relative col-span-12`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.endereco} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'endereco')} id="endereco" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={100} placeholder=" " autoComplete='off' value={endereco} onFocus={searchBoxFocus} onChange={logradouroChange} />
                                            <label htmlFor="endereco" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Logradouro</label>
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-8 xl:col-span-6`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.bairro} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'bairro')} id="bairro" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' maxLength={60} placeholder=" " autoComplete='off' value={bairro} onFocus={searchBoxFocus} onChange={bairroChange} />
                                            <label htmlFor="bairro" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Bairro</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.numero} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'numero')} id="numero" className={`${classInput} ${classInputDark}`} type="text" inputMode='numeric' maxLength={20} placeholder=" " autoComplete='off' value={numero} onFocus={searchBoxFocus} onChange={numeroChange} />
                                            <label htmlFor="numero" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Número</label>
                                        </div>

                                        <input
                                            type="text"
                                            name="fake_autofill_field"
                                            style={{ display: 'none' }}
                                            autoComplete="username"
                                        />

                                        <div className={`relative col-span-12 sm:col-span-8 md:col-span-8 lg:col-span-5 xl:col-span-4`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.complemento} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'complemento')} id="complemento" className={`${classInput} ${classInputDark} `} type="text" inputMode='text' maxLength={100} placeholder=" " autoComplete='off' value={complemento} onFocus={searchBoxFocus} onChange={complementoChange} />
                                            <label htmlFor="complemento" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Complemento</label>
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-7 xl:col-span-6`}>

                                            <div ref={inputsRefs['uf']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'uf')} />
                                            <div className={`${barraVermelhoAzul} ${idUf > 0 ? bgBlue : bgRed}`} />
                                            <SearchBox
                                                dataList={uf}
                                                idRegistro={idUf || undefined}
                                                label='Estado'
                                                componentId='uf'
                                                borda={true}
                                                visibleTAB={visibleSearchBoxUF}
                                                clearDataClick={handleClearUfSelecionada}
                                                setDataClick={handleUfSelectClick}
                                                filterDataClick={handleFilterUfClick}
                                                clicado={clickSearchBoxUF}

                                            />
                                        </div>

                                        <div className={`relative col-span-12 xl:col-span-6`}>

                                            <div ref={inputsRefs['cidade']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'cidade')} />
                                            <div className={`${barraVermelhoAzul} ${idCity > 0 ? bgBlue : bgRed}`} />
                                            <SearchBox
                                                dataList={cidade}
                                                idRegistro={idCity || undefined}
                                                label='Cidade'
                                                componentId='cidade'
                                                borda={true}
                                                visibleTAB={visibleSearchBoxCity}
                                                clearDataClick={handleClearCidadeSelecionada}
                                                setDataClick={handleCidadeSelectClick}
                                                filterDataClick={handleFilterCidadeClick}
                                                clicado={clickSearchBoxCidade}

                                            />
                                        </div>

                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <div className={`flex flex-col lg:flex-row ${parseInt(idForn || '0') > 0 ? 'sm:space-y-0 lg:space-x-0 space-y-1' : 'lg:space-y-0 lg:space-x-4 space-y-4'}`}>

                                        <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/fornecedor" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                            <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                        </Link>

                                        <button tabIndex={-1} onClick={abrirModalConsultaCNPJ} className={` ${parseInt(idForn || '') > 0 || id > 0 || tabs[1].active ? 'invisible hidden' : 'visible'} ${classbtColunasAzul} ${classWeigthBt}`}>
                                            <span>Consultar CNPJ</span>
                                        </button>

                                    </div>

                                    <div className={`flex flex-col lg:flex-row ${parseInt(idForn || '0') > 0 ? 'sm:space-y-0 lg:space-x-0 space-y-1' : 'lg:space-y-0 lg:space-x-4 space-y-4'}  `}>

                                        <button tabIndex={-1} onClick={novoFornecedor} className={`${classBt} ${btNovoVisible} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                            <AiOutlineClear size="20px" className='mr-[5px]' /> Limpar Campos
                                        </button>

                                        <button tabIndex={-1} onClick={handleSaveFornecedor} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt}`} >
                                            {!loading && <IoSave size="16px" className='mr-[5px]' />}
                                            {loading &&
                                                <div className="h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]"
                                                    role="status">
                                                    <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
                                                </div>
                                            }
                                            {parseInt(idForn || '0') > 0 || id != 0 ? !loading ? 'Atualizar' : 'Aguarde...' : !loading ? 'Salvar' : 'Aguarde...'}
                                        </button>

                                    </div>

                                </div>

                            </div>

                            <div className={`${tabs[1].active ? 'block' : 'hidden'} relative`}>

                                <div className='grid w-full h-full grid-cols-12 gap-5 p-4'>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-3`}>
                                        <div className={`${barraVermelhoAzul} ${nomeContatoForn != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefsContato.nomeContato} onKeyDown={(e: React.KeyboardEvent) => handleTabPressContato(e, 'nomeContato')} id="nome_contato_forn" className={`${classInput} ${classInputDark} ${nomeContatoForn != '' ? '' : focusRed}`} type="text" inputMode='text' maxLength={155} placeholder=" " autoComplete='off' value={nomeContatoForn} onChange={changeNomeContatoTransp} />
                                        <label htmlFor="nome_contato_forn" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${nomeContatoForn != '' ? '' : focusLabelRed}`}>Nome do contato</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-3`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefsContato.emailContato} onKeyDown={(e: React.KeyboardEvent) => handleTabPressContato(e, 'emailContato')} id="email_contato_forn" className={`${classInput} ${classInputDark} ${idContatoForn != 0 && listContato[0]?.email ? 'cursor-not-allowed' : ''}`} type="email" inputMode='email' maxLength={155} placeholder=" " autoComplete='off' disabled={idContatoForn != 0 && listContato[0]?.email ? true : false} value={emailContatoForn} onChange={changeEmailContatoForn} />
                                        <label htmlFor="email_contato_forn" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Email</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${condFone}`} />
                                        <InputMask ref={inputsRefsContato.telefoneContato} onKeyDown={(e: React.KeyboardEvent) => handleTabPressContato(e, 'telefoneContato')} id="fone_contato_forn" className={`${classInput} ${classInputDark}  ${condFone == 'bg-red-900' ? focusRed : ``}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={foneContatoForn} onChange={changeFoneContatoForn} mask="(99) 9999-9999" alwaysShowMask={true} />
                                        <label htmlFor="fone_contato_forn" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${condFone == 'bg-red-900' ? focusLabelRed : ``} `}>Telefone</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${condCell}`} />
                                        <InputMask ref={inputsRefsContato.celularContato} onKeyDown={(e: React.KeyboardEvent) => handleTabPressContato(e, 'celularContato')} id="celular_contato_forn" className={`${classInput} ${classInputDark} ${condCell == 'bg-red-900' ? focusRed : ``}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={celContatoForn} onChange={changeCelContatoForn} mask="(99) 99999-9999" alwaysShowMask={true} />
                                        <label htmlFor="celular_contato_forn" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${condCell == 'bg-red-900' ? focusLabelRed : ``}`}>Celular</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefsContato.descricaoContato} onKeyDown={(e: React.KeyboardEvent) => handleTabPressContato(e, 'descricaoContato')} id="setor_contato_forn" className={`${classInput} ${classInputDark}   `} type="text" inputMode='text' maxLength={60} placeholder=" " autoComplete='off' value={setorContatoForn} onChange={changeSetorContatoForn} />
                                        <label htmlFor="setor_contato_forn" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Setor</label>
                                    </div>

                                </div>

                                <div className={`relative overflow-hidden hover:overflow-auto p-4`}>

                                    <GridContatoFornecedor
                                        fornecedor={fornecedores}
                                        auditoriaContact={abrirModalContatoAuditoria}
                                        editContact={handleContactEdit}
                                        excluirContact={handleExcluirClick}
                                    />

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/fornecedor" className={`${classbtColunasVermelho}  ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                    </Link>

                                    <button tabIndex={-1} onClick={novoContatoFornecedor} className={`${classBt} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className={`text-white mr-[5px]`} />Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onClick={handleContatoSave} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt}`}>
                                        {!loading && <IoSave size="16px" className='mr-[5px]' />}
                                        {loading &&
                                            <div className="h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]"
                                                role="status">
                                                <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
                                            </div>
                                        }
                                        {idContatoForn != 0 ? !loading ? 'Atualizar' : 'Aguarde...' : !loading ? 'Salvar' : 'Aguarde...'}
                                    </button>


                                </div>
                            </div>

                            <div className={`${tabs[2].active ? 'block' : 'hidden'} relative h-[400px] sm:h-[200px]`}>

                                <div className={`w-full h-full flex flex-row p-4`}>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userCriacaoForn" className={`${classUserCriarAtt}`}>Criador</label>
                                            <span id="userCriacaoForn" className={`${classDtCriarAtt}`}>{userCriador}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtCriacaoForn" className={`${classUserCriarAtt}`}>Data de Criação</label>
                                            <span id="dtCriacaoForn" className={`${classDtCriarAtt}`}>{dtCriador}</span>
                                        </div>

                                    </div>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userAttForn" className={`${classUserCriarAtt}`}>Atualizador</label>
                                            <span id="userAttForn" className={`${classDtCriarAtt}`}>{usertAtt}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtAttForn" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                                            <span id="dtAttForn" className={`${classDtCriarAtt}`}>{dtAtt}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <ModalConsultaCNPJ
                        visible={modalConsultaVisible}
                        loading={loadingCnpj}
                        CloseModalEvent={fecharModalConsultaCNPJ}
                        ConsultarCNPJEvent={handleConsultarCNPJ} />

                    <ModalExcluirDados
                        show={modalShow}
                        isLoading={loadingExcluir}
                        message={`Deseja excluir o contato - ${nomeContatoExcluir || ''}?`}
                        closeModalEvent={fecharModalExclusao}
                        excluirEvent={handleExcluir}
                        fecharModalEvent={buttonFecharModalExcluirDados}
                    />

                    <ModalAuditoria
                        visible={modalAuditoriaVisible}
                        listaAtributos={listAuditoriaContato}
                        closeModalEvent={fecharModalAuditoria}
                    />

                    <ModalImportacao
                        visible={visibleImportacao}
                        formFields={formFields}
                        closeModalEvent={fecharModalImportacao}
                        importarDados={importarDados}
                    />


                    {modalTutorialVisible &&
                        <ModalTutorial
                            linkVideo='/tutorial_fornecedor.mp4'
                            title='Como cadastrar um fornecedor'
                            visible={modalTutorialVisible}
                            onCloseClick={() => setModalTutorialVisible(false)}
                        />
                    }
                    
                </div>

            </div>

        </Template>
    )
}